import { Injectable, inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { ApplicationState } from '../shared/store/application-state';
import { AddAjaxRotatorAction, RemoveAjaxRotatorAction } from './store/navigation.actions';

@Injectable()
export class AjaxRotatorService {
	private counter = 0;
	private activeRotators = new Set();
	private router = inject(Router);
	private store = inject(Store<ApplicationState>);

	constructor() {
		this.router.events
			.pipe(filter(e => e instanceof NavigationStart))
			.subscribe(() => this.addPageLoadRotator());

		this.router.events
			.pipe(filter(e => e instanceof NavigationEnd || e instanceof NavigationCancel || e instanceof NavigationError))
			.subscribe(() => this.removePageLoadRotator());
	}

	public addRotator(): number {
		const id = this.counter++;
		this.activeRotators.add(id);
		this.store.dispatch(new AddAjaxRotatorAction());
		return id;
	}

	public addPageLoadRotator(): void {
		this.activeRotators.add('pageLoad');
		this.store.dispatch(new AddAjaxRotatorAction());
	}

	public removePageLoadRotator(): void {
		this.removeRotator('pageLoad' as unknown as number);
	}

	public removeRotator(id: number): void {
		this.activeRotators.delete(id);
		if (!this.activeRotators.size) {
			this.store.dispatch(new RemoveAjaxRotatorAction());
		}
	}
}
